<template>
    <div class="main-panel">
        <div class="content-wrapper dashboard-shell">
            <div class="cardplay solicitudes-card">
                <div class="row dashboard-header g-3 align-items-center mb-4">
                    <div class="col-lg-8">
                        <div class="d-flex align-items-center gap-2 mb-1">
                            <span class="header-icon"><i class="fa-solid fa-file-signature"></i></span>
                            <h2 class="dashboard-title mb-0">Solicitudes</h2>
                        </div>
                        <p class="solicitudes-subtitle mb-0">
                            Revisa y gestiona solicitudes por estado sin perder las funcionalidades actuales.
                        </p>
                    </div>
                    <div class="col-lg-4 d-flex justify-content-lg-end justify-content-start">
                        <a href="/solicitud/integrante/0" class="btn btn-dark dashboard-action-btn">
                            <i class="fa-solid fa-plus me-2"></i> Crear nueva solicitud
                        </a>
                    </div>
                </div>

                <div class="row g-3 mb-3">
                    <div class="col-md-4 col-sm-6">
                        <div class="summary-chip">
                            <label for="estadoSolicitud" class="chip-label mb-2 d-block">Mostrar solicitudes</label>
                            <select v-model="filtradoMostrar" required class="form-select filter-select" name="estadoSolicitud"
                                id="estadoSolicitud" placeholder="Estado">
                                <option value="Pendiente">Pendientes</option>
                                <option value="Aprobado">Aprobadas</option>
                                <option value="Otorgado">Otorgadas</option>
                                <option value="Rechazado">Rechazadas</option>
                                <option value="Todos">Todas</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-8 col-sm-6">
                        <div class="summary-chip summary-info d-flex align-items-center h-100">
                            <i class="fa-solid fa-circle-info me-2"></i>
                            <span>Puedes cambiar el filtro para refrescar automáticamente la tabla de solicitudes.</span>
                        </div>
                    </div>
                </div>

                <div class="table-wrapper">
                    <TablaSolicitudes :key="`${filtradoMostrar}`" :mostrar="this.filtradoMostrar" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TablaSolicitudes from './TablaSolicitudesPendientes.vue';

export default {
    name: 'MostrarSolicitudes',
    data() {
        return {
            solicitudes: [],
            data: [],
            dateFormated: '',
            ready: false,
            filtradoMostrar: 'Pendiente'
        }
    },
    components:{
        TablaSolicitudes
    },
    methods: {
   
        formatearFecha(fechaOriginal) {
            // Función para formatear solo la fecha en el nuevo formato
            const fecha = new Date(fechaOriginal);
            const opciones = { year: 'numeric', month: '2-digit', day: '2-digit' };
            return fecha.toLocaleDateString('es-ES', opciones);
        },
        dateFormat(param) {
            const date = new Date(param)

            const dia = (param)?.slice(8, 10)
            const mes = date.toLocaleDateString('es-ES', { month: 'long' })
            const anio = date.getFullYear()
            const dateFormated = `${dia}/${mes.slice(0, 3)}/${anio}`
            return dateFormated
        },

    }

}
</script>

<style scoped>
.dashboard-shell {
    background: linear-gradient(165deg, #f5f7fb 0%, #eef1f7 45%, #f8fafc 100%);
    min-height: 100vh;
}

.cardplay {
    border-radius: 24px;
    border: 1px solid #e5e7eb;
    padding: 32px;
    background-color: #ffffff;
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
}

.dashboard-header {
    background: linear-gradient(120deg, #111827 0%, #1f2937 70%, #374151 100%);
    border-radius: 18px;
    color: #fff;
    padding: 16px 18px;
}

.header-icon {
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.18);
}

.dashboard-title {
    color: #fff;
    font-weight: 700;
    letter-spacing: 0.4px;
}

.solicitudes-subtitle {
    color: #e5e7eb;
    font-size: 0.95rem;
}

.summary-chip {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    padding: 12px 14px;
}

.chip-label {
    margin-bottom: 4px;
    color: #64748b;
    font-size: 0.82rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.35px;
}

.summary-info {
    color: #334155;
    font-size: 0.92rem;
}

.dashboard-action-btn {
    border-radius: 12px;
    padding: 0.62rem 1rem;
    font-weight: 600;
    background: #111827 !important;
    border-color: #111827 !important;
    box-shadow: 0 8px 20px rgba(17, 24, 39, 0.25);
}

.dashboard-action-btn:hover {
    background: #1f2937 !important;
    border-color: #1f2937 !important;
}

.filter-select {
    border-radius: 10px;
    border: 1px solid #cbd5e1;
}

.table-wrapper {
    border: 1px solid #e5eaf0;
    border-radius: 16px;
    overflow: hidden;
    background: #ffffff;
    padding: 12px;
}

@media (max-width: 767px) {
    .cardplay {
        padding: 15px;
    }

    .dashboard-action-btn {
        width: 100%;
    }
}

.row > * {
    margin-block: 5px !important;
}
</style>
